import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { CoreMenuService } from '@core/components/core-menu/core-menu.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-main-side-bar',
  templateUrl: './main-side-bar.component.html',
  styleUrls: ['./main-side-bar.component.scss']
})
export class MainSideBarComponent implements OnInit {

  currentUser: any;
  selectedItem:any;
  openSpecificMenu:any = false;
  selectedSpecificItem :any = false;

  @Input()
  layout = 'vertical';

  @Input()
  menu: any;

  @Input() enableSidebar:any;

  // Private
  private _unsubscribeAll: Subject<any>;

  @Output() closeSideBarEvent: EventEmitter<any>;


  /**
   *
   * @param {ChangeDetectorRef} _changeDetectorRef
   * @param {CoreMenuService} _coreMenuService
   */
  constructor(private _changeDetectorRef: ChangeDetectorRef, private _coreMenuService: CoreMenuService ,private _router: Router) {
    // Set the private defaults
    this._unsubscribeAll = new Subject();
    this.closeSideBarEvent = new EventEmitter();
  }

  // Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Set the menu either from the input or from the service
    this.menu = this.menu || this._coreMenuService.getCurrentMenu();

    // Subscribe to the current menu changes
    this._coreMenuService.onMenuChanged.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
      this.currentUser = this._coreMenuService.currentUser;
      console.log(this.currentUser , "iuserf")

      // Load menu
      this.menu = this._coreMenuService.getCurrentMenu();

      this._changeDetectorRef.markForCheck();
      console.log(this.menu , "_____")
  
    });
  }


  showOrHideArrow(item){
    if(item && item.children && item.children.length >0){
      return true
    }
    return false;
  }

  showSubMenu(item){
    if(item.title == this.selectedItem && this.openSpecificMenu){
      this.selectedItem == null;
      this.openSpecificMenu = false;
      this._changeDetectorRef.markForCheck();
    } else {
      this.selectedItem = item.title
      this.openSpecificMenu = true;
    }
  }

  selectItem(item){
    if(item && item.children && item.children.length >0){
      this.selectedItem = item.title
      this.openSpecificMenu = true;
    } else {
      this.selectedItem = item.title;
      this._router.navigate([`${item.url}`]);
    }

  }

  selectSpecificItem(specificitem){
    this.selectedSpecificItem = specificitem.title;
    this._router.navigate([`${specificitem.url}`]);
  }

  closeSideBar(){
    this.closeSideBarEvent.emit(true);
  }

}
